export const AppendVideoElement = (src: string, loop?: boolean) => {
	const v = document.createElement("video");
	v.src = src;
	v.crossOrigin = "anonymous";
	v.loop = loop ? loop : false;
	document.getElementById("container")?.appendChild(v);
	return v;
}